import { z } from "zod";

export const jsonLdSchema = z.object({
  _id: z.string(),
  jsonLd: z.string().transform((v) => JSON.parse(v) as object),
});

export function JsonLdScript({ json }: { json: object }) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: serializeJsonLd(json),
      }}
    />
  );
}

const SCRIPT_UNSAFE_CHARACTERS = /[<>&\u2028\u2029]/g;
const JSON_ESCAPES: Record<string, string> = {
  "<": "\\u003c",
  ">": "\\u003e",
  "&": "\\u0026",
  "\u2028": "\\u2028",
  "\u2029": "\\u2029",
};

/**
 * Serializes JSON-LD without HTML entities, which are treated as literal text
 * inside script elements. Escaping HTML-significant characters as JSON unicode
 * sequences also prevents user-authored content from closing the script tag.
 */
function serializeJsonLd(json: object): string {
  return JSON.stringify(json, (_key, value: unknown) =>
    value === null ? undefined : value
  ).replace(
    SCRIPT_UNSAFE_CHARACTERS,
    (character) => JSON_ESCAPES[character] ?? character
  );
}
